import { useState } from 'react';
import { useNavigate } from "react-router-dom";

import { firestoreMethods } from '../../firebase/firestoreMethods';

function SiteForm({mode, site}) {

  const navigate = useNavigate();
  
  const initFormState = 
    {
      name: '',
      category: '',
      url: '',
      address_url: '', 
      home_url: '',
      notes: '', 
    };

  const addFields = 
    [
      "name", 
      "category",
      "url", 
      "address_url",
      "home_url", 
      "notes", 
    ];

  const editFields = 
    [
      "name", 
      "category",
      "url",
      "address_url", 
      "home_url",
      "notes", 
    ];
  const fields = (mode.toUpperCase() === 'ADD') ? addFields : editFields;

  const [inputs, setInputs] = useState(site || initFormState);

  const handleChange = (e) => {
    const {name, value} = e.target
    // since we are adding fields constantly, this check is ncessary
    /*setInputs((prev) => {
        // Copy the array (your code was doing that)
        const update = {...prev};
        console.log("update1: ", update);
        update[name] = value;
        console.log("update2: ", update);

        return update;
    });
    */
    
    setInputs(prev => ({...prev, [name]: value}))

  }

  const handleSubmit = async () => {
    let siteId=site && site.id;
    if (mode.toUpperCase() === 'ADD') {
      siteId = await firestoreMethods.addSite(inputs);
    } else {
      await firestoreMethods.updateSite(site.id, inputs);
      //setRefreshSite(true);
    }
    //setRefreshAllVenues(true);
    setInputs(initFormState);
    navigate(`/admin/sites/${siteId}/view`);
  }

  return (
    <>
        {fields.map((field) => 
          {
            return <div className="form-field" key={field}>
              <div className='form-label'>{field}</div>
              <input 
                name={field}
                type="text" 
                onChange={(handleChange)} 
                value={inputs[field] || ''}
                className='form-input'
              />  
            </div>
          })

        }
    
      <div className='form-button-group'>
        <div className='form-button primary' onClick={handleSubmit}>
          Submit
        </div>
        <div className='form-button' onClick={() => navigate(-1)}>
          Cancel
        </div>
      </div>
    </>
  );

}


export default SiteForm;
